'use strict';

import React, { Component, PropTypes } from 'react';
import { Checkbox, Icon, Spinner, Alert } from './';
import gql from 'graphql-tag';

import '../../scss/components/_customer.scss';

export default class Customer extends Component {
	handleClickCheckbox(e) {
		this.props.onChangeSelection(e.target.checked);
	}

	handleClickEdit(e) {
		e.preventDefault();

		this.props.onEdit();
	}

	handleClickDelete(e) {
		e.preventDefault();

		this.props.onDelete();
	}

	handleClickManageLinks(e) {
		e.preventDefault();

		this.props.onManageLinks();
	}

	handleClickAlert() {
		this.props.onHideError();
	}

	render() {
		let manager;

		if (this.props.customer.managerUser) {
			manager = this.props.customer.managerUser.fullName;
		} else {
			manager = (
				<span>
					Not assigned <Icon type="warning-circle" />
				</span>
			);
		}

		return (
			<div className="customer-card">
				<If condition={this.props.canEdit}>
					<Checkbox
						name={`customer-${this.props.customer.id}`}
						onChange={e => this.handleClickCheckbox(e)}
						checked={this.props.isSelected}
						disabled={this.props.isDeleting}
					/>
				</If>

				<div className="customer-card-details">
					<div className="pull-left">
						<h1>{this.props.customer.name}</h1>
						<span className="customer-card-label">Billing ID</span>{' '}
						{this.props.customer.billingId}
						<br />
						<span className="customer-card-label">Account Manager</span> {manager}
					</div>
					<If condition={this.props.canEdit}>
						<div className="pull-right">
							<Choose>
								<When condition={this.props.isDeleting}>
									<Spinner style="inline" />
								</When>
								<Otherwise>
									<a href="#" onClick={e => this.handleClickManageLinks(e)}>
										<Icon type="list" />
									</a>
									<a href="#" onClick={e => this.handleClickEdit(e)}>
										<Icon type="pencil" />
									</a>
									<If condition={this.props.canDelete}>
										<a href="#" onClick={e => this.handleClickDelete(e)}>
											<Icon type="trash" />
										</a>
									</If>
								</Otherwise>
							</Choose>
						</div>
					</If>
					<If condition={this.props.error}>
						<Alert style="error" canDismiss onClick={() => this.handleClickAlert()}>
							{this.props.error}
						</Alert>
					</If>
				</div>
			</div>
		);
	}
}

Customer.fragments = {
	customer: gql`
		fragment CustomerResults on CustomerCollection {
			results {
				id
				name
				billingId
				dfpAdvertiserId
				invoiceFields
				emails {
					email
				}
				managerUser {
					id
					fullName
					email
				}
			}
			numTotal
		}
	`,
};

Customer.propTypes = {
	customer: PropTypes.object.isRequired,
	onManageLinks: PropTypes.func,
	onChangeSelection: PropTypes.func,
	onHideError: PropTypes.func,
	onEdit: PropTypes.func,
	onDelete: PropTypes.func,
	isSelected: PropTypes.bool,
	isDeleting: PropTypes.bool,
	canEdit: PropTypes.bool,
	canDelete: PropTypes.bool,
	error: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/assets/js/components/Customer.js